<template>
  <div>
    <div class="d-flex">
      <el-radio v-model="radio" label="all"
                @change="handleClickAllTask()"
      >Tất cả
      </el-radio>
      <el-radio v-model="radio" label="notDone"
                @change="getNotDoneTask()"
      >Chưa xong
      </el-radio>
      <el-radio v-model="radio" label="done" @change="getDoneTask()"
      >Đã xong
      </el-radio>
      <el-radio v-model="radio" label="outDate"
                @change="handleClickTaskOutDate()"
      >Quá hạn
      </el-radio>
      <el-radio v-if="role==='assignees'" v-model="radio" label="notReceived"
                @change="handleClickTaskNotReceived()"
      >Chưa nhận
      </el-radio>
      <el-radio v-if="role==='assignees'" v-model="radio" label="reveived"
                @change="handleClickTaskReceived()"
      >Đã nhận
      </el-radio>


    </div>
    <div class=" mt-3"></div>

    <ZaloTodoList :selectedAccount="selectedAccount" :data_list="data" />

  </div>
</template>

<script>

import ZaloTodoList from "./ZaloTodoList";

export default {
  name: "ZaloTodo",
  components: { ZaloTodoList },
  props: {
    data_list: {
      type: Array
    },
    role: {
      type: String
    },
    selectedAccount: {
      type: Object
    }
  },
  data() {
    return {
      radio: "all",
      data: [],
      statusActive: {
        notDone: "notDone",
        done: "done",
        outDate: "outDate",
        notReceived: "notReceived",
        reveived: "reveived",
        all: "all"
      }
    };
  },
  watch: {
    /*    radio: function() {
          if (this.radio === "all") {
            this.handleClickAllTask();
          } else if (this.radio === "notDone") {
            this.getNotDoneTask();
          } else if (this.radio === "done") {
            this.getDoneTask();
          } else if (this.radio === "outDate") {
            this.handleClickTaskOutDate();
          } else if (this.radio === "notReceived") {
            this.handleClickTaskNotReceived();
          } else if (this.radio === "reveived") {
            this.handleClickTaskReceived();
          }
        },*/
    data_list: function() {
      // this.handleClickAllTask();
      if (this.radio === "all") {
        this.handleClickAllTask();
      } else if (this.radio === "notDone") {
        this.getNotDoneTask();
      } else if (this.radio === "done") {
        this.getDoneTask();
      } else if (this.radio === "outDate") {
        this.handleClickTaskOutDate();
      } else if (this.radio === "notReceived") {
        this.handleClickTaskNotReceived();
      } else if (this.radio === "reveived") {
        this.handleClickTaskReceived();
      }
    }
    /*    radio: function() {
          if (this.radio === "all") {
            this.handleClickAllTask();
          } else if (this.radio === "notDone") {
            this.getNotDoneTask();
          } else if (this.radio === "outDate") {
            this.handleClickTaskOutDate();
          } else if (this.radio === "notReceived") {
            this.handleClickTaskNotReceived();
          } else if (this.radio === "reveived") {
            this.handleClickTaskReceived();
          }
        }*/
  },
  methods: {

    handleClickAllTask() {
      this.data = this.data_list;
    },
    handleClickTaskOutDate() {
      this.data = this.getOutDateSize();
    },
    handleClickTaskNotReceived() {
      this.data = this.getTaskNotReceived();
    },
    handleClickTaskReceived() {
      this.data = this.getTaskReveived();
    },

    getTaskNotReceived() {
      let maybeItems = this.data_list.filter(s => s.status === -1);
      let items = [];
      maybeItems.forEach(s => {
        let item = s.assignees.find(s => s.userId === this.selectedAccount.accountId);
        if (item && item.status === -1) {
          items.push(s);
        }
      });
      return items;

    },

    getTaskReveived() {
      let items = this.data_list.filter(s => s.status === 0);
      let seflItems = items.filter(s => s.assignees.find(t => t.userId === this.selectedAccount.accountId && t.status === 1));
      for (let item of seflItems) {
        let index = items.indexOf(item);
        if (index > -1) {
          items.splice(index,1);
        }
      }
      let maybeItems = this.data_list.filter(s => s.status === -1);
      maybeItems.forEach(s => {
        let item = s.assignees.find(s => s.userId === this.selectedAccount.accountId);
        if (item && item.status === 0) {
          items.push(s);
        }
      });
      return items.sort((s1,s2) => Number(s2.updateTime)-Number(s1.updateTime));
    },
    getOutDateSize() {
      return this.data_list.filter(s => s.status !== 1 && s.dueDate !== -1 && s.dueDate < new Date().getTime());
    },
    getSizeNotDone() {
      return this.data_list.filter(s => s.status === -1 || s.status === 0).length;
    },
    getSizeDone() {
      return this.data_list.filter(s => s.status === 1).length;
    },


    getNotDoneTask() {
      this.data = this.data_list.filter(s => (s.status === -1 && s.assignees.find(t => t.userId === this.selectedAccount.accountId && t.status !== 1)) || ( s.status === 0 && s.assignees.find(t => t.userId === this.selectedAccount.accountId && t.status !== 1)));
    },
    getDoneTask() {
      let data = this.data_list.filter(s => s.status === 1 || s.assignees.find(t => t.userId === this.selectedAccount.accountId && t.status === 1));
      this.data = data;
    },
    autoFocus() {

    }
  },

  mounted() {

  }
};
</script>

<style scoped>
.el-dropdown-link:hover {
  cursor: pointer;
  color: #005ae0;
}

.nav-todo {
  border-radius: 999px;
  font-weight: 500
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>